import { AutoMenu } from '@Core/Components/AutoMenu/AutoMenu'
import { IMenu } from '@Core/Components/AutoMenu/AutoMenu.types'
import { usePermissions } from '@Core/Hooks/usePermissions'
import { SidebarFolder } from '@Entry/Common/Sidebar/components/SidebarFolder/SidebarFolder'
import { useMemo } from 'react'
import { AiOutlineShoppingCart } from 'react-icons/ai'
import { useLocation } from 'react-router-dom'
import { RoutesPaths } from './RoutesPaths'
import { moduleKey, roles } from './roles'

const MenuItems: IMenu[] = [
    {
        title: 'Processos',
        to: RoutesPaths.PurchasingList,
        icon: <AiOutlineShoppingCart />,
        permission: roles.process.permissions.read.key,
    },
    {
        title: 'Fornecedores',
        to: RoutesPaths.PurchasingSuppliers,
        icon: <AiOutlineShoppingCart />,
        permission: roles.supplier.permissions.read.key,
    },
    {
        title: 'Relatórios',
        to: RoutesPaths.PurchasingReports,
        icon: <AiOutlineShoppingCart />,
        permission: roles.report.permissions.read.key,
    },
]

export const Menu = () => {
    const { pathname } = useLocation()
    const { hasModulePermission } = usePermissions()
    const hasSubMenuActive = useMemo(
        () =>
            Boolean(
                MenuItems.find(
                    (item) =>
                        item.to === pathname ||
                        (item.to === RoutesPaths.PurchasingList &&
                            pathname.startsWith('/purchasing'))
                )
            ),
        [pathname]
    )

    if (!hasModulePermission(moduleKey)) return <></>
    return (
        <SidebarFolder
            name="Compras"
            icon={<AiOutlineShoppingCart />}
            active={hasSubMenuActive}
        >
            <AutoMenu menu={MenuItems} />
        </SidebarFolder>
    )
}
